import { reducerActions } from '../cartConsts';

export default function cartItemsReducer(state = {}, action) {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case reducerActions.setCartItems:
      state = payload;
      break;
    default:
      break;
  }

  return state;
}
